<app-header></app-header>

<main class="contact-container">
  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">
        Get in
        <span class="gradient-text">Touch</span>
      </h1>
      <p class="hero-subtitle">
        Have questions or need assistance? We're here to help. Choose from our
        support options below to get the help you need.
      </p>
    </div>
  </section>

  <section class="contact-section">
    <div class="contact-container-inner">
      <div class="contact-wrapper">
        <div class="contact-info">
          <div class="contact-method">
            <div class="method-icon-container">
              <span class="method-icon">💬</span>
            </div>
            <h3 class="method-title">Help Center</h3>
            <p class="method-description">
              Browse through our knowledge base to find answers to common
              questions.
            </p>
            <a routerLink="/help-center" class="method-detail"
              >Visit Help Center →</a
            >
          </div>

          <div class="contact-method">
            <div class="method-icon-container">
              <span class="method-icon">🕐</span>
            </div>
            <h3 class="method-title">Support Hours</h3>
            <p class="method-description">
              Monday - Friday<br />
              9:00 AM - 5:00 PM (CET)
            </p>
            <div class="method-detail">Response within 24 hours</div>
          </div>
        </div>

        <div class="contact-form-container">
          <h2 class="form-title">How to Reach Us</h2>

          <div class="contact-options" *ngIf="!showContactForm && !isLoggedIn">
            <div class="contact-option">
              <div class="option-icon-container">
                <span class="option-icon">🔒</span>
              </div>
              <h3 class="option-title">Login Required</h3>
              <p class="option-description">
                Please log in to your account to submit a support ticket. This
                helps us provide better, personalized assistance.
              </p>
              <button class="action-button primary" (click)="navigateToLogin()">
                <span class="button-icon">🔑</span>
                <span>Login to Continue</span>
              </button>
            </div>

            <div class="contact-option">
              <div class="option-icon-container">
                <span class="option-icon">👤</span>
              </div>
              <h3 class="option-title">New User?</h3>
              <p class="option-description">
                Don't have an account yet? Create one to access our support
                system and manage your listings.
              </p>
              <button
                class="action-button secondary"
                (click)="navigateToRegister()"
              >
                <span class="button-icon">✨</span>
                <span>Create Account</span>
              </button>
            </div>
          </div>

          <div class="contact-options" *ngIf="!showContactForm && isLoggedIn">
            <div class="contact-option">
              <div class="option-icon-container">
                <span class="option-icon">📝</span>
              </div>
              <h3 class="option-title">Send us a Message</h3>
              <p class="option-description">
                Fill out our contact form and we'll respond within 24 hours.
              </p>
              <button class="action-button primary" (click)="showForm()">
                <span class="button-icon">✉️</span>
                <span>Open Contact Form</span>
              </button>
            </div>
          </div>

          <div
            class="contact-form-wrapper"
            *ngIf="showContactForm && isLoggedIn"
            id="contact-form"
          >
            <div class="form-header">
              <h3 class="form-subtitle">Send us a Message</h3>
              <button class="close-form-btn" (click)="hideForm()" type="button">
                <span>✕</span>
              </button>
            </div>

            <div
              class="submission-message"
              *ngIf="isSubmitted"
              [class.success]="submitSuccess"
              [class.error]="!submitSuccess"
            >
              <div class="message-icon">
                <span *ngIf="submitSuccess">✅</span>
                <span *ngIf="!submitSuccess">❌</span>
              </div>
              <div class="message-content">
                <p>{{ submitMessage }}</p>
                <div class="message-actions" *ngIf="submitSuccess">
                  <button
                    class="action-button tertiary small"
                    (click)="hideForm()"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>

            <form
              [formGroup]="contactForm"
              (ngSubmit)="onSubmit()"
              class="contact-form"
              *ngIf="!isSubmitted"
            >
              <div class="form-row">
                <div class="form-group">
                  <label for="name" class="form-label">Name *</label>
                  <input
                    type="text"
                    id="name"
                    formControlName="name"
                    class="form-input"
                    [class.error]="isFieldInvalid('name')"
                    placeholder="Your full name"
                  />
                  <div class="field-error" *ngIf="isFieldInvalid('name')">
                    {{ getFieldError("name") }}
                  </div>
                </div>

                <div class="form-group">
                  <label for="email" class="form-label">
                    Email *
                    <span
                      class="auto-filled-indicator"
                      *ngIf="currentUser?.email"
                    >
                      (Auto-filled)
                    </span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    formControlName="email"
                    class="form-input auto-filled"
                    [class.error]="isFieldInvalid('email')"
                    placeholder="your@email.com"
                    readonly
                  />
                  <div class="field-error" *ngIf="isFieldInvalid('email')">
                    {{ getFieldError("email") }}
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label for="phone" class="form-label"
                    >Phone <span class="optional">(optional)</span></label
                  >
                  <input
                    type="tel"
                    id="phone"
                    formControlName="phone"
                    class="form-input"
                    [class.error]="isFieldInvalid('phone')"
                    placeholder="+1234567890"
                  />
                  <div class="field-error" *ngIf="isFieldInvalid('phone')">
                    {{ getFieldError("phone") }}
                  </div>
                </div>

                <div class="form-group">
                  <label for="subject" class="form-label">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    formControlName="subject"
                    class="form-input"
                    [class.error]="isFieldInvalid('subject')"
                    placeholder="Brief description of your inquiry"
                  />
                  <div class="field-error" *ngIf="isFieldInvalid('subject')">
                    {{ getFieldError("subject") }}
                  </div>
                  <div class="character-count">
                    {{ getCharacterCount("subject") }}/200
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="message" class="form-label">Message *</label>
                <textarea
                  id="message"
                  formControlName="message"
                  class="form-textarea"
                  [class.error]="isFieldInvalid('message')"
                  placeholder="Please provide details about your question or issue..."
                  rows="6"
                ></textarea>
                <div class="field-error" *ngIf="isFieldInvalid('message')">
                  {{ getFieldError("message") }}
                </div>
                <div class="character-count">
                  {{ getCharacterCount("message") }}/5000
                </div>
              </div>

              <div class="form-footer">
                <div class="form-info">
                  <p class="info-text">
                    <span class="info-icon">🔒</span>
                    Your information is secure and will only be used to respond
                    to your inquiry.
                  </p>
                </div>

                <div class="form-actions">
                  <button
                    type="button"
                    class="action-button tertiary"
                    (click)="hideForm()"
                    [disabled]="isSubmitting"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    class="action-button primary"
                    [disabled]="contactForm.invalid || isSubmitting"
                  >
                    <span *ngIf="!isSubmitting" class="button-icon">📤</span>
                    <span *ngIf="isSubmitting" class="loading-spinner"></span>
                    <span>{{
                      isSubmitting ? "Sending..." : "Send Message"
                    }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>
